import Link from 'next/link'
import { FC } from 'react'

import { CategoriesList } from '@/screensComponents/CategoriesList/СategoriesList'

import type { CatalogItem } from '@/entities/catalog/types'

import { Col } from '@/shared/ui/Grid'
import { Row } from '@/shared/ui/Grid'

import styles from './NotFound.module.scss'

export type NotFoundProps = {
	title: string
	catalogItems: CatalogItem[]
}

export const NotFound: FC<NotFoundProps> = ({ title, catalogItems }) => (
	<section className={styles.page404}>
		<Row className={styles.content}>
			<Col lg={10} md={24}>
				<h1 className={styles.title}>{title}</h1>
			</Col>
			<Col lg={10} md={24}>
				<p className={styles.subtitle}>Страница не работает. Зато работают ссылки</p>

				<ul className={styles.list}>
					<li className={styles.listItem}>
						<Link prefetch={false} href="/catalog/apple_iphone/" className={styles.link}>
							Каталог iPhone
						</Link>
					</li>
					<li className={styles.listItem}>
						<Link prefetch={false} href="/shops/" className={styles.link}>
							Магазины
						</Link>
					</li>
					<li className={styles.listItem}>
						<Link prefetch={false} href="/services/iport-card/" className={styles.link}>
							Бонусная программа
						</Link>
					</li>
				</ul>
			</Col>
		</Row>

		<CategoriesList catalogItems={catalogItems} />
	</section>
)
